module.exports = __webpack_public_path__ + "img/INS.5fae6803.svg";